export default {
	init() {
		// JavaScript to be fired on all pages

		$('#toggle-mobile').click(function(e) {
			e.preventDefault();
			$(this).toggleClass('open-nav');
			$('body').toggleClass('secondary-nav-is-open');
			$('body').removeClass('collections-nav-is-open');
		});

		$('#open-collections-nav').click(function(e) {
			e.preventDefault();
			$('body').addClass('collections-nav-is-open');
		});

		$('#close-collections-nav').click(function(e) {
			e.preventDefault();
			$('body').removeClass('collections-nav-is-open');
			$('body').removeClass('collections-nav-is-open-desktop');
		});

		$('#toggle-collections').click(function(e) {
			e.preventDefault();
			$('body').addClass('collections-nav-is-open-desktop');
		});

		$('#toggle-search').click(function(e) {
			e.preventDefault();
			$('body').addClass('fullscreen-search-is-open');
		});

		$('#close-fullscreen-search').click(function(e) {
			e.preventDefault();
			$('body').removeClass('fullscreen-search-is-open');
		});

		$('.frm_form_field select').each(function(){
			$(this).wrapAll('<div class="select-wrapper" />')
		});

		// Inspiration Modal
		$('.open-fullscreen-inspiration').click(function(e) {
			e.preventDefault();
			var img_path_elem = $(this).parents('.item').find('input');

			var medium = $(img_path_elem).data('medium');
			var medium_large = $(img_path_elem).data('medium-large');
			var large = $(img_path_elem).data('large');
			var alt = $(img_path_elem).data('alt');

			var picture_elem = '<picture><source srcset="' + medium + '" media="(max-width:767px)" /><source srcset="' + medium_large + '" media="(min-width:768px)" /><source srcset="' + large + '" media="(min-width:1024px)" /><img src="' + medium_large + '" alt="' + alt + '" /></picture>';

			$('.inspiration-container').empty();
			$('.inspiration-container').append(picture_elem);
			$('body').addClass('fullscreen-inspiration-is-open');
		});
		$('#close-fullscreen-inspiration').click(function(e) {
			e.preventDefault();
			$('body').removeClass('fullscreen-inspiration-is-open');
		});


		// View Type
		$('.collection').addClass('grid');
		$('#view-grid').closest('li').addClass('active');

		$('#view-grid').click(function(e) {
			e.preventDefault();
			$(this).closest('li').siblings('li').removeClass('active');
			$(this).closest('li').addClass('active');
			$('.collection').addClass('grid').removeClass('list');
		});

		$('#view-list').click(function(e) {
			e.preventDefault();
			$(this).closest('li').siblings('li').removeClass('active');
			$(this).closest('li').addClass('active');
			$('.collection').addClass('list').removeClass('grid');
		});

		// Price Accordion
		$('.price-accordion #reveal-price').click(function(e) {
			e.preventDefault();
			$(this).siblings('section').slideToggle(350);
			$(this).parent().toggleClass('price-revealed');
		});

		// Product Slider
		$('.product-slider').on('init', function(event, slick){
			$(this).append('<div class="slider-count"><p><span id="current">1</span> of <span id="total">'+slick.slideCount+'</span></p></div>');
			});
			$('.product-slider').slick({
				arrows: true,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				fade: true,
				adaptiveHeight: true,
				appendArrows: $('.product-slider-arrows'),
				prevArrow: '<button type="button" data-role="none" class="slick-prev"><i class="icon-chevron-left"></i><span>Previous</span></button>',
				nextArrow: '<button type="button" data-role="none" class="slick-next"><span>Next</span><i class="icon-chevron-right"></i></button>',
			});
			$('.product-slider')
			.on('afterChange', function(event, slick, currentSlide){
			// finally let's do this after changing slides
			$('.slider-count #current').html(currentSlide+1);
		});


	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js